module.exports = __webpack_public_path__ + "img/img-eeda79.jpg";